/**
 * Display-only labels for enum-like values from the API.
 * Does not change stored or transmitted values.
 */

export function translatePriorityDisplay(p, t) {
  if (!p || p === "—") return null;
  const k = String(p).trim().toLowerCase();
  if (["critical", "high", "medium", "low"].includes(k)) {
    return t(`common.severity.${k}`);
  }
  return String(p).trim();
}

const FINDING_STATUS_TO_KEY = {
  open: "open",
  closed: "closed",
  problem: "problem",
  resolved: "resolved",
  "in progress": "inProgress",
};

export function translateFindingStatusDisplay(raw, t) {
  const v = String(raw ?? "").trim();
  if (!v) return t("common.status.open");
  const key = FINDING_STATUS_TO_KEY[v.toLowerCase()];
  return key ? t(`common.status.${key}`) : v;
}

const ACTION_PROGRESS_TO_KEY = {
  "not started": "notStarted",
  "in progress": "inProgress",
  completed: "completed",
  problem: "problem",
  open: "open",
};

export function translateActionProgressLabel(raw, t) {
  const v = String(raw ?? "").trim() || "Not started";
  const key = ACTION_PROGRESS_TO_KEY[v.toLowerCase()];
  return key ? t(`common.status.${key}`) : v;
}

const KANBAN_STAGE_TO_KEY = {
  Open: "open",
  "In Progress": "inProgress",
  Problem: "problem",
  Completed: "completed",
};

export function translateKanbanColumnTitle(stage, t) {
  const key = KANBAN_STAGE_TO_KEY[stage];
  return key ? t(`actionsPage.kanban.columns.${key}`) : stage;
}
